module.exports = __webpack_public_path__ + "static/media/porte-bagage-trailer.dbc8769d.mp4";